import { ShipmentCreate, ShipmentEdit } from "./ShipmentForms";
import { ShipmentList } from "./ShipmentList";
import { ShipmentShow } from "./ShipmentShow";
import type { Shipment } from "./types";

export default {
  list: ShipmentList,
  create: ShipmentCreate,
  edit: ShipmentEdit,
  show: ShipmentShow,
  recordRepresentation: (record: Shipment) => record.invoice_number,
};
